export const BASE_API_URL = 'https://app.bitafit.com';
export const API_TOKEN_TYPE = 'Bearer';
export const AUTH_TOKEN_TYPE = 'Basic';
export const COOKIE_TOKEN_ACCESS = 'btf-widg-acc';
export const LOGIN_URL = `${BASE_API_URL}/auth/realms/${process.env.AUTH_LOGIN_PATH}/protocol/openid-connect/token`;

export const API_START = `${BASE_API_URL}/${process.env.AUTH_PREFIX_CORE}/api`;
